import Icon from '2-core-elements/Icon/Icon';
import clsx from 'clsx';
import type { FC, PropsWithChildren } from 'react';

interface FieldHelperProps extends PropsWithChildren {
    type?: 'error' | 'default' | 'disabled' | 'success' | 'warning';
    withIcon?: boolean;
    className?: string;
}

const FieldHelper: FC<FieldHelperProps> = ({
    type = 'default',
    withIcon = true,
    children,
    className,
}) => {
    let iconName = '';

    switch (type) {
    case 'error':
        iconName = 'cross-circle';
        break;
    case 'disabled':
        iconName = 'error-circle';
        break;
    case 'success':
        iconName = 'check-circle';
        break;
    case 'warning':
        iconName = 'warning';
        break;
    default:
        iconName = '';
    }

    return (
        <div className={clsx(`field-helper is-${type}`, className)}>
            {withIcon && (
                <Icon
                    icon={iconName}
                    className="field-helper-icon"
                />
            )}
            <div className="field-helper-message">{children}</div>
        </div>
    );
};

export default FieldHelper;
